var exports = {
  "e7": "MonaHead__cARNFC",
  "MR": "MonaHead__artwork__qNXRpE",
  "F$": "MonaHead__particles__-4uppB",
  "aH": "MonaHead__particle__ZjzAW7",
};

module.exports = exports;
